export default __webpack_public_path__ + "static/media/close.8ff189c2.svg";